import { render, staticRenderFns } from "./riderWiseOFDReport.vue?vue&type=template&id=68d6a2f7&"
import script from "./riderWiseOFDReport.vue?vue&type=script&lang=js&"
export * from "./riderWiseOFDReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports